import { render, staticRenderFns } from "./Separator.vue?vue&type=template&id=50c6784b&scoped=true"
import script from "./Separator.vue?vue&type=script&lang=js"
export * from "./Separator.vue?vue&type=script&lang=js"
import style0 from "./Separator.vue?vue&type=style&index=0&id=50c6784b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c6784b",
  null
  
)

export default component.exports